export function oneOf(keys, data) {
    return keys.reduce((acc, key) => {
        if (data[key] && !acc) return data[key];
        return acc;
    }, null);
}
